import template from 'lodash/template';

export default {
  parseObjectList(list) {
    list.forEach((o) => this.parseObject(o));
  },

  parseObject(o) {
    this.localize(document.querySelector('#' + o.id), o);
  },

  localize(itm, o) {
    if (!itm) {
      return;
    }
    if (typeof o.visible !== 'undefined' && !o.visible) {
      itm.remove(itm);
    }
    if (o.label) {
      const labels = Array.from(itm.querySelectorAll('.label'));
      if (labels.length) {
        labels.forEach((label) => {
          label.innerHTML = o.label;
        });

        if (o.properties) {
          Object.keys(o.properties).forEach((p) => {
            itm[p] = o.properties[p];
          });
        }
      } else {
        const span = document.createElement('span');
        span.innerHTML = o.label;

        itm.appendChild(span);

        if (o.properties) {
          Object.keys(o.properties).forEach((p) => {
            if (p == 'style') {
              span[p] = o.properties[p];
            } else {
              itm[p] = o.properties[p];
            }
          });
        }
      }
    } else {
      if (o.properties) {
        Object.keys(o.properties).forEach((p) => {
          itm[p] = o.properties[p];
        });
      }
    }
  },

  template(code, vals) {
    if ('content' in document.createElement('template')) {
      const el = document.createElement('template');
      el.innerHTML = template(code)(vals);
      return el.content;
    } else {
      const el = document.createElement('div');
      el.innerHTML = template(code)(vals);
      return el.firstChild;
    }
  },
};
